import classNames from 'classnames';

import { Cell } from '@/explore/types';
import { SortableItemVertical } from '@/explore/components/sortable-item';
import { Icon } from '@/components/icon';

import styles from './exploration-outline.module.scss';

export const getCellTitle = (cell: Cell) =>
  cell.kind === 'text'
    ? 'Text block'
    : 'title' in cell
      ? cell.title !== ''
        ? cell.title
        : '(Untitled Block)'
      : cell.kind === 'variable'
        ? cell.definition.key
        : '(Untitled Block)';

type CellItemProps = {
  cell: Cell;
  index: number;
  draggedIndex: number | null;
  setDraggedIndex: (index: number | null) => void;
  onMove: (fromIndex: number, toIndex: number, after: boolean) => void;
  onClickCell: (cellId: string) => void;
};

export const CellItem = ({
  cell,
  index,
  draggedIndex,
  setDraggedIndex,
  onMove,
  onClickCell,
}: CellItemProps) => {
  return (
    <SortableItemVertical
      key={index}
      scope="exploration-outline-cells"
      index={index}
      draggedIndex={draggedIndex}
      setDraggedIndex={setDraggedIndex}
      onReorder={onMove}
      className={classNames(styles.cellItem, styles.sortableItem)}
      classNames={{
        dragBefore: styles.dragBefore,
        dragAfter: styles.dragAfter,
      }}>
      <Icon name="DragHandle" size={10} className={styles.sortHandle} />
      <a onClick={() => onClickCell(cell.id)}>{getCellTitle(cell)}</a>
    </SortableItemVertical>
  );
};
